'use client'

import { Tabs as TabsUI, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { cn } from '@/lib/utils'

export const Tabs = ({
  tabs,
  defaultValue,
  noPadding = false,
  source = 'sections',
  value,
  classNames,
  tabChange,
}: {
  tabs: { id: string; title: string; content: React.ReactNode | string }[]
  defaultValue: string
  value?: string
  noPadding?: boolean
  triggerClassName?: string
  tabListClassName?: string
  source?: 'sections' | 'menu'
  classNames?: {
    tabs?: string
    tabsList?: string
    tabsTrigger?: string
    tabsContent?: string
  }
  tabChange?: (tab: 'OUTSTANDING' | 'PAID') => void
}) => {
  return (
    <TabsUI defaultValue={defaultValue} value={value} className={cn('relative w-full', classNames?.tabs)}>
      <TabsList
        className={cn(
          !noPadding ? 'gap-0 text-grey-500' : 'gap-6 text-grey-700',
          'no-scrollbar flex w-full justify-start overflow-x-auto border-b border-grey-200',
          source === 'sections' && 'absolute',
          classNames?.tabsList,
        )}
      >
        {tabs.map((tab) => (
          <TabsTrigger
            key={tab.id}
            value={tab.id}
            className={cn(!noPadding ? 'px-6 py-3' : 'pb-4', classNames?.tabsTrigger)}
            onClick={() => tabChange?.(tab.id as 'OUTSTANDING' | 'PAID')}
          >
            {tab.title}
          </TabsTrigger>
        ))}
      </TabsList>
      {tabs.map((tab) => (
        <TabsContent value={tab.id} key={tab.id} className={cn(source === 'sections' ? 'pt-[72px]' : 'pt-6', classNames?.tabsContent)}>
          {tab.content}
        </TabsContent>
      ))}
    </TabsUI>
  )
}
